import React, { Component } from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';
import "./holidays.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import { default as ReactSelect, components, InputProps } from "react-select";
import WeekOffs from '../WeekOffs/WeekOffs';

class Holidays extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'holidays',

            // FILTERS
            filterModal: false,
            filterApplied: false,
            filterIid: '',
            filterAcaYr: '',
            filterDepartment: '',
            filterFromDate: '',
            filterToDate: '',
            filterTitle: '',
            isValid: true,

            holidayList: {},
            holidaySortedIdArray: {},
            acaYear: '',
            totalHolidays: '',
            Loadingholidays: false,
            departmentList: {},
            addHoliday: false,
            selectedDepartmentObject: '',
            selectedDepartment: [],
            AcademicYearList: [],
            selectedAcademicYearObject: '',
            selectedAcademicYear: [],
            validFromDate: '',
            validToDate: '',
            selectedIid: '',
            departments: {},

            // METHOD TO RETURN DELETE
            deleteAccess: false,
            deletingAccess: '',
            deleteAccessText: '',
            deleteWarning: '',
            deletingId: '',
            CollegeId: '',

            holidayEditMode: false,
            holidayCopyMode: false,

            //VARIABLES FOR EDIT MODE
            editAcaYear: '',
            uniqueIdEdit: '',

            //SUCCESS MODAL VARIABLES
            successModal: false,
            successModalType: "",
            successMessage: "",

            isEmpty: false,
            errorMessage: '',
            dateErrorMessage: '',
            title: '',
            offset: 0,
            pageIndex: 1,
            limit: 10,
        }
    }

    componentDidMount() {
        this.apiCallToGetHolidaysList();
    }

    // API CALL TO GET HOLIDAY DATA LIST
    apiCallToGetHolidaysList = async () => {
        this.setState({
            Loadingholidays: true
        });

        let iidArray = [];

        if (this.state.filterIid != '') {
            iidArray = [this.state.filterIid]
        } else {
            iidArray = this.props.iidArray.iidArray // this.props.assignedIIDArray
        }

        let requestData = {
            "iidArray": iidArray,
            "title": this.state.filterTitle.trim(),
            "sid": this.state.filterDepartment,
            "fromDate": this.state.filterFromDate,
            "toDate": this.state.filterToDate,
            "acaYearId": this.state.filterAcaYr,
            "limit": this.state.limit,
            "offset": this.state.offset,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryHolidaysList',
            requestData,
            "/api/library/libraryHolidays.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetHolidaysList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        holidayList: apiResult.data,
                        holidaySortedIdArray: apiResult.sortedIdArray,
                        totalHolidays: apiResult.Total,
                        Loadingholidays: false
                    })
                }
                else {
                    this.setState({
                        holidayList: {},
                        holidaySortedIdArray: {},
                    })
                }
            } else {
                this.setState({
                    holidayList: {},
                    holidaySortedIdArray: {},
                })
            }
        }
    }

    // API CALL TO GET FACULTY STREAM DATA LIST
    GetInstituteStreamsObject = async () => {

        let getIid = '';

        if (this.state.filterIid != '') {
            getIid = this.state.filterIid
        } else {
            getIid = this.state.selectedIid
        }


        let requestData = {
            "iid": getIid,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteStreamsObject();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.departmentList(apiResult.data)

                    this.setState({
                        departments: apiResult.data,
                    })

                }
                else {
                    this.setState({
                        departmentList: [],
                        departments: {}
                    })
                }
            } else {
                this.setState({
                    departmentList: [],
                    departments: {}
                })
            }
        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    //Below method will add new holiday by making an API call.
    apiCallToAddHoliday = async () => {

        let academicYear = '';

        if (this.state.holidayCopyMode) {
            academicYear = [this.state.editAcaYear]
        } else {
            academicYear = this.state.selectedAcademicYear
        }

        let requestData = {
            'institute_id': this.state.selectedIid,
            'title': this.state.title,
            'academic_year': academicYear,
            'department': this.state.selectedDepartment,
            'from_date': this.state.validFromDate,
            'to_date': this.state.validToDate,
            'added_by': config.faculty_id,
        }

        //Following method will make an API call and return a response.
        let jsonResponse = await LibraryApiCall.makeApiCall(
            "addLibraryHoliday",
            requestData,
            "/api/library/libraryHolidays.php",
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAddHoliday();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status === 'success') {
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: ReactHtmlParser(jsonResponse.APIResult.message),
                    }, () => { this.apiCallToGetHolidaysList(); this.closeAddHoliday() });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: jsonResponse.APIResult.message,
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding holiday. Please try again later.',
                });
            }
        }
    }

    // API CALL METHOD TO DELETE ACCESS
    apiCallToDeleteHoliday = async () => {
        // this.setState({
        //     deletingAccess: true
        // });

        let requestData = {
            "institute_id": this.state.CollegeId,
            "unique_id": this.state.deletingId,
            "updatedBy": config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'deleteLibraryHoliday',
            requestData,
            '/api/library/libraryHolidays.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeleteHoliday();
            }, 1000);
        }
        else {
            this.closeDeleteAccess();
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult.status == 'success') {

                    this.setState({
                        // deletingAccess: false,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                    }, () => this.apiCallToGetHolidaysList());
                } else {
                    this.setState({
                        // deletingAccess: false,
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            }
            else {
                this.setState({
                    // deletingAccess: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while deleting holiday. Please try again later.'
                });
            }
        }
    }

    // API  CALL METHOD TO UPDATE ACCESS DETAILS
    apiCallToUpdateHoliday = async () => {

        let requestData = {
            "institute_id": this.state.selectedIid,
            "department": this.state.selectedDepartment,
            "title": this.state.title,
            "academic_year": this.state.editAcaYear,
            "from_date": this.state.validFromDate,
            "to_date": this.state.validToDate,
            "updated_by": config.faculty_id,
            "unique_id": this.state.uniqueIdEdit
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'updateLibraryHoliday',
            requestData,
            '/api/library/libraryHolidays.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateHoliday();
            }, 1000);
        }
        else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {

                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: ReactHtmlParser(jsonResponse.APIResult.message),
                    }, () => { this.apiCallToGetHolidaysList(); this.closeAddHoliday() });

                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });
                }
            }
            else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while updating holiday. Please try again later.'
                });
            }
        }
    }

    // METHODS TO SET STATES
    departmentList = (departmentData) => {
        let departmentList = [];
        Object.keys(departmentData).map((keys, index) => {
            let department = departmentData[keys]
            let options = { "value": keys, "label": department.stream_name };
            departmentList.push(options);
        })
        this.setState({
            departmentList: departmentList,
        })
    }

    AcademicYearList = () => {
        let AcademicYearList = [];
        Object.keys(config.academicInfo).map((keys) => {
            let acaYear = config.academicInfo[keys]
            let options = { "value": acaYear.YearId, "label": acaYear.YearText };
            AcademicYearList.push(options);
        })
        this.setState({
            AcademicYearList: AcademicYearList,
        })
    }

    // METHOD TO SELECT LIMIT
    selectLimit = (e) => {
        this.setState({
            limit: e.target.value,
            pageIndex: 1,
            offset: 0,
        }, () => {
            // METHOD CALLED TO GET holidays DETAILS
            this.apiCallToGetHolidaysList();
        });
    }

    // METHOD TO UPDATE PAGINATION PAGE NUMBER
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit,
        }, () => {
            // METHOD CALLED TO GET holidays DETAILS
            this.apiCallToGetHolidaysList();
        });
    }

    // METHOD TO SELECT EVENT TYPE
    selectEventType = (type) => {
        if (this.state.activeTab != type) {
            this.setState({
                activeTab: type
            })
        }
    }

    selectDepartments = (selectedOption) => {
        let selectDepartment = this.state.selectedDepartment;
        selectDepartment = [];

        if (selectedOption.length > 0) {
            selectedOption.map(option => {
                if (!selectDepartment.includes(option.value)) {
                    selectDepartment.push(option.value);
                }
            })
        }
        this.setState({
            selectedDepartment: selectDepartment
        });
    }

    selectAcaYear = (selectedOption) => {
        let selectAcaYear = this.state.selectedAcademicYear;
        selectAcaYear = [];

        if (selectedOption.length > 0) {
            selectedOption.map(option => {
                if (!selectAcaYear.includes(option.value)) {
                    selectAcaYear.push(option.value);
                }
            })
        }
        this.setState({
            selectedAcademicYear: selectAcaYear
        });
    }

    //CLEAR FILTERS
    clearFilters = () => {
        this.setState({
            filterIid: '',
            filterAcaYr: '',
            filterDepartment: '',
            filterFromDate: '',
            filterToDate: '',
            isValid: true,
            dateErrorMessage: '',
            filterApplied: false,
            filterModal: false
        }, () => this.apiCallToGetHolidaysList());
    }

    // METHOD TO RETURN ADD NEW HOLIDAY
    returnAddNewHoliday = () => {
        const customStyles = {
            option: (provided) => ({
                ...provided,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
                fontSize: '10px'
            }),
        };
        return (
            <div id="addAccessSideMenu" style={{ display: this.state.addHoliday ? 'flex' : 'none' }}>
                <div id="addHolidayDataContainer" style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px' }}>
                    <div className='pl-4 pr-2'>
                        <div className="d-flex justify-content-between pt-4 pb-2">
                            <h5 className="col-11 pl-4">{this.state.holidayEditMode ? "Update Holiday" : this.state.holidayCopyMode ? "Copy Holiday" : "Add New Holiday"}</h5>
                            <span className="pr-4">
                                <FontAwesomeIcon icon={['fas', 'times']} size="md" color="#000" onClick={() => this.closeAddHoliday()} style={{ cursor: "pointer" }} />
                            </span>
                        </div>
                        <hr className='pl-4' />
                        <div className="col-md-12 pt-2">
                            <div>
                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Title<span style={{ color: 'red' }}> *</span></label>

                                <input
                                    type="text"
                                    className="form-control"
                                    style={{ width: "100%", paddingLeft: "10px" }}
                                    placeholder='Enter Title'
                                    value={this.state.title}
                                    onChange={(e) => this.setState({ title: e.target.value })}
                                    maxLength={250}
                                />
                            </div>
                            <p className="d-flex justify-content-end" style={{ color: '#7A7A7A', fontSize: '10px' }}>(Maximum 250 characters are allowed.)</p>

                            {
                                !this.state.holidayEditMode &&
                                <div className="pt-4">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Institute<span style={{ color: 'red' }}> *</span></label>

                                    <select
                                        className="form-control"
                                        value={this.state.selectedIid}
                                        onChange={(e) => { this.setState({ selectedIid: e.target.value, departmentList: [], selectedDepartmentObject: '', selectedDepartment: [], selectedAcademicYearObject: '' }, () => { this.GetInstituteStreamsObject(); }) }}
                                    >
                                        <option value="">Select Institute</option>
                                        {
                                            Object.values(this.props.multipleInstituteDetails.multipleInstituteDetails).map(instituteList => {
                                                return (
                                                    <option value={instituteList.iid}>{instituteList.institute_name}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                            }
                            <div className='d-flex pt-5'>

                                <div className="col-md-6 pl-0">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Academic Year<span style={{ color: 'red' }}> *</span></label>

                                    {
                                        this.state.holidayEditMode || this.state.holidayCopyMode ?
                                            (
                                                <select
                                                    className="form-control"
                                                    value={this.state.editAcaYear}
                                                    onChange={(e) => { this.setState({ editAcaYear: e.target.value }, () => { this.GetInstituteStreamsObject(); }) }}
                                                >
                                                    <option value="">Select Academic Year</option>
                                                    {
                                                        Object.values(config.academicInfo).map(keys => {
                                                            return (
                                                                <option value={keys.YearId}>{keys.YearText}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            )
                                            :
                                            (
                                                <ReactSelect
                                                    className='upperSelectBoxZIndex'
                                                    value={this.state.selectedAcademicYearObject}
                                                    options={this.state.AcademicYearList}
                                                    defaultValue=""
                                                    isMulti
                                                    isClearable
                                                    closeMenuOnSelect={false}
                                                    hideSelectedOptions={false}
                                                    styles={customStyles}
                                                    onChange={(e) => {
                                                        this.setState({ selectedAcademicYearObject: e })
                                                        this.selectAcaYear(e)
                                                    }
                                                    }
                                                />
                                            )
                                    }
                                </div>
                                <div className="col-md-6 pr-0">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Department<span style={{ color: 'red' }}> *</span></label>

                                    <ReactSelect
                                        className='upperSelectBoxZIndex'
                                        value={this.state.selectedDepartmentObject}
                                        options={this.state.departmentList}
                                        defaultValue=""
                                        isMulti
                                        isClearable
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        styles={customStyles}
                                        isDisabled={!this.state.selectedIid}
                                        onChange={(e) => {
                                            this.setState({ selectedDepartmentObject: e })
                                            this.selectDepartments(e)
                                        }
                                        }
                                    />
                                </div>
                            </div>
                            <div className='d-flex pt-5'>
                                <div className="col-md-6 pl-0">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>From Date<span style={{ color: 'red' }}> *</span></label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ width: "100%", paddingLeft: "10px" }}
                                        placeholder='Enter Title'
                                        value={this.state.validFromDate}
                                        onChange={(e) => { this.setState({ validFromDate: e.target.value }, () => { this.validateDates(); }) }}
                                    />
                                </div>
                                <div className="col-md-6 pr-0">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>To Date<span style={{ color: 'red' }}> *</span></label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ width: "100%", paddingLeft: "10px" }}
                                        placeholder='Enter Title'
                                        value={this.state.validToDate}
                                        disabled={!this.state.validFromDate}
                                        onChange={(e) => { this.setState({ validToDate: e.target.value }, () => { this.validateDates(); }) }}
                                    />
                                </div>
                            </div>
                            <p className='text-danger fs-12 pt-2'>{this.state.errorMessage}</p>
                            <p className='text-danger fs-12 pt-2'>{this.state.dateErrorMessage}</p>
                        </div>
                        <div id="addHolidayFooter" className="modal-footer pt-3">
                            <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddHoliday()}>Cancel</button>
                            <button className="btn btn-primary"
                                onClick={() => this.validateAddHoliday()}
                            > {this.state.holidayEditMode ? "Update Holiday" : this.state.holidayCopyMode ? "Copy Holiday" : "Add Holiday"}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO VALIDATE ADD HOLIDAY
    validateAddHoliday = () => {

        if (this.state.holidayEditMode) {

            if (this.state.title == '' || this.state.selectedIid == '' || this.state.editAcaYear == '' || this.state.selectedDepartmentObject == '' || this.state.validFromDate == '' || this.state.validToDate == '') {
                this.setState({
                    isEmpty: true,
                    errorMessage: 'Please fill out all mandatory fields before proceeding.'
                });
            } else if (this.state.isValid == true) {
                this.setState({
                    isEmpty: false,
                    errorMessage: ''
                }, () => {
                    this.apiCallToUpdateHoliday();
                });
            }
        } else if (this.state.holidayCopyMode) {

            if (this.state.title == '' || this.state.selectedIid == '' || this.state.editAcaYear == '' || this.state.selectedDepartmentObject == '' || this.state.validFromDate == '' || this.state.validToDate == '') {
                this.setState({
                    isEmpty: true,
                    errorMessage: 'Please fill out all mandatory fields before proceeding.'
                });
            } else if (this.state.isValid == true) {
                this.setState({
                    isEmpty: false,
                    errorMessage: ''
                }, () => {
                    this.apiCallToAddHoliday();
                });
            }
        }
        else {
            if (this.state.title == '' || this.state.selectedIid == '' || this.state.selectedAcademicYearObject == '' || this.state.selectedDepartmentObject == '' || this.state.validFromDate == '' || this.state.validToDate == '') {
                this.setState({
                    isEmpty: true,
                    errorMessage: 'Please fill out all mandatory fields before proceeding.'
                });
            } else if (this.state.isValid == true) {
                this.setState({
                    isEmpty: false,
                    errorMessage: ''
                }, () => {
                    this.apiCallToAddHoliday();
                });
            }
        }
    }

    // METHOD TO CHECK ACCESS FOR ADD OPERATION
    checkAddHoliday = () => {
        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {
            this.setState({
                addHoliday: true,
                holidayEditMode: false,
                holidayCopyMode: false,
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    //METHOD TO CHECK ACCESS FOR COPY OPERATION
    checkCopyAccess = (holiday) => {
        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {
            let streamIds = holiday.sidArray;
            let sidWiseName = holiday.sidWiseName;
            let selectedDepartmentObject = [];
            Object.keys(sidWiseName).map((sid) => {
                let stream_name = sidWiseName[sid];
                let options = { "value": sid, "label": stream_name };
                selectedDepartmentObject.push(options);
            })

            let selectedDepartment = holiday.sidArray;

            this.setState({
                addHoliday: true,
                holidayCopyMode: true,
                holidayEditMode: false,
                title: holiday.Title,
                selectedIid: holiday.CollegeId,
                selectedAcademicYearObject: [holiday.AcayrID],
                validFromDate: holiday.Fromdate,
                validToDate: holiday.Todate,
                editAcaYear: holiday.AcayrID,
                selectedDepartment: selectedDepartment,
                uniqueIdEdit: holiday.Uniqueid,
                selectedDepartmentObject
            }, () => {
                this.GetInstituteStreamsObject();
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO CLOSE ADD HOLIDAY MODAL
    closeAddHoliday = () => {
        this.setState({
            addHoliday: false,
            validToDate: '',
            validFromDate: '',
            title: '',
            selectedIid: '',
            selectedAcademicYearObject: [],
            validFromDate: '',
            validToDate: '',
            selectedDepartmentObject: [],
            errorMessage: '',
            dateErrorMessage: ''
        });
    }

    // METHOD TO CLOSE ADD HOLIDAY MODAL
    closefilterModal = () => {
        this.setState({
            filterModal: false,
            // filterIid: '',
            // filterAcaYr: '',
            // filterDepartment: '',
            // filterFromDate: '',
            // filterToDate: '',
            // isValid: true,
            dateErrorMessage: '',
        });
    }

    // METHOD TO RETURN ADVANCED FILTERS
    returnAdvancedFilterModal = () => {
        return (
            <div id="modalContainer" className={this.state.filterModal ? "modal fade show" : "modal fade"}>
                <div className='modal-dialog modal-dialog-centered' style={{ maxWidth: '45VW', minHeight: "calc(100% - 10.5rem)" }}>
                    <div className='modal-content' style={{ borderRadius: '10px' }}>
                        <div className='modal-header p-3'>
                            <h3 style={{ textTransform: "none", fontSize: 20 }}>Advanced Filters</h3>
                            <FontAwesomeIcon
                                icon={["fas", "times"]}
                                style={{ cursor: "pointer" }}
                                size='md'
                                color='#000000'
                                onClick={() => this.closefilterModal()}
                            />
                        </div>
                        <div className='modal-body'>
                            <div className='pl-1 pr-1'>
                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Institute</label>

                                <select
                                    className="form-control"
                                    value={this.state.filterIid}
                                    onChange={(e) => { this.setState({ filterIid: e.target.value, pageIndex: 1, offset: 0, departmentList: [], filterDepartment: '' }, () => { this.GetInstituteStreamsObject(); }) }}

                                >
                                    <option value="">Select Institute</option>
                                    {
                                        Object.values(this.props.multipleInstituteDetails.multipleInstituteDetails).map(instituteList => {
                                            return (
                                                <option value={instituteList.iid}>{instituteList.institute_name}</option>
                                            );
                                        })
                                    }
                                </select>
                            </div>
                            <div className='d-flex pt-3'>
                                <div className='col-md-6 pl-1'>
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Academic Year</label>

                                    <select
                                        className="form-control"
                                        value={this.state.filterAcaYr}
                                        onChange={(e) => this.setState({ filterAcaYr: e.target.value, pageIndex: 1, offset: 0 })}
                                    >
                                        <option value="">Select Academic Year</option>
                                        {
                                            Object.values(config.academicInfo).map(keys => {
                                                return (
                                                    <option value={keys.YearId}>{keys.YearText}</option>
                                                );
                                            })
                                        }
                                    </select>
                                </div>
                                <div className='col-md-6 pr-1'>
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Department</label>

                                    <select
                                        className="form-control"
                                        value={this.state.filterDepartment}
                                        onChange={(e) => this.setState({ filterDepartment: e.target.value, pageIndex: 1, offset: 0 })}
                                    >
                                        {this.state.filterIid !== '' ? (
                                            <>
                                                <option value="">Select Department</option>
                                                {Object.keys(this.state.departments).map(keys => {
                                                    let dept = this.state.departments[keys];
                                                    return (
                                                        <option key={keys} value={keys}>{dept.stream_name}</option>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <option value="">Please select institute.</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='d-flex pt-3'>
                                <div className="col-md-6 pl-1">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>From Date</label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ width: "100%", paddingLeft: "10px" }}
                                        placeholder='Enter Title'
                                        value={this.state.filterFromDate}
                                        onChange={(e) => { this.setState({ filterFromDate: e.target.value, pageIndex: 1, offset: 0 }, () => { this.validateDates(); }) }}
                                    />
                                </div>
                                <div className="col-md-6 pr-1">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>To Date</label>

                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ width: "100%", paddingLeft: "10px" }}
                                        placeholder='Enter Title'
                                        value={this.state.filterToDate}
                                        onChange={(e) => { this.setState({ filterToDate: e.target.value, pageIndex: 1, offset: 0 }, () => { this.validateDates(); }) }}
                                    />
                                </div>
                            </div>
                            <p className='text-danger fs-12 pt-2'>{this.state.dateErrorMessage}</p>
                        </div>
                        <div className='modal-footer'>
                            <button className="btn btn-outline-primary waves-effect p-1" style={{ borderRadius: '5px' }} onClick={() => this.clearFilters()}>Clear</button>
                            <button className="btn btn-primary"
                                style={{ borderRadius: '5px' }}
                                onClick={() => this.applyFilters()}
                            >Apply Filters</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Apply filters
    applyFilters = () => {
        if (this.state.isValid == true) {
            this.apiCallToGetHolidaysList();

            if(this.state.filterIid.length > 0 || this.state.filterAcaYr.length > 0 || this.state.filterDepartment.length > 0 || this.state.filterTitle.length > 0 || this.state.filterFromDate.length > 0 || this.state.filterToDate.length > 0) {
                this.setState({
                    filterApplied: true,
                })
            } else {
                this.setState({
                    filterApplied: false,
                })
            }

            this.setState({
                filterModal: false,
                pageIndex: 1,
                offset: 0
            })
        }
    }

    //Date Validation
    validateDates = () => {
        if (this.state.filterFromDate.length > 0) {
            if (
                this.state.filterFromDate.length &&
                this.state.filterToDate.length &&
                this.state.filterToDate < this.state.filterFromDate) {
                this.setState({
                    isValid: false,
                    dateErrorMessage: 'To Date cannot be before than from date.'
                })
            } else {
                this.setState({
                    isValid: true,
                    dateErrorMessage: ''
                })
            }
        } else {
            if (
                this.state.validFromDate.length &&
                this.state.validToDate.length &&
                this.state.validToDate < this.state.validFromDate) {
                this.setState({
                    isEmpty: true,
                    isValid: false,
                    dateErrorMessage: 'To Date cannot be before than from date.'
                })
            } else {
                this.setState({
                    isEmpty: false,
                    isValid: true,
                    dateErrorMessage: ''
                })
            }
        }
    }

    // METHOD TO RETURN DELETE ACCESS
    returnDeleteAccess = () => {
        return (
            <div className={this.state.deleteAccess ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog" style={{ marginTop: '10%', marginLeft: '25%', }} >
                    <div className="modal-content " style={{ width: '50vw' }}>
                        <div className="modal-header  deleteModalHeader">
                            <h2 style={{ color: "white" }}><FontAwesomeIcon icon={['fas', 'exclamation-triangle']} color="white" size="am" style={{ marginRight: 20 }} /> Are you sure?</h2>
                            <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="white" onClick={() => this.closeDeleteAccess()} style={{ cursor: "pointer" }} />
                        </div>
                        <div className="modal-body deleteModalBody">
                            <p style={{ fontSize: 16, fontWeight: "bold" }}>NOTE:</p>
                            <ul className="pl-5">
                                <li>Once deleted cannot be retrieved.</li>
                                <li>All data associated with this entry will be deleted permanently.</li>
                            </ul>
                            <p className="pl-5 deleteConfirmationText">If you want to delete the entry , type <b>DELETE PERMANENTLY</b> in block/capital letters in below input text for confirmation.</p>
                            <div className="pl-5">
                                <input
                                    type="text"
                                    style={{ width: "260px" }}
                                    value={this.state.deleteAccessText}
                                    onChange={(e) => e.target.value != 'DELETE PERMANENTLY' ? this.setState({ deleteAccessText: e.target.value, deleteWarning: 'Please enter DELETE PERMANENTLY to delete access.' }) : this.setState({ deleteAccessText: e.target.value, deleteWarning: '' })}
                                    placeholder="Please type DELETE PERMANENTLY"
                                    maxLength={18}
                                    onPaste={(e) => e.preventDefault()}
                                />
                            </div>
                            <p style={{ marginLeft: 50, color: 'red', fontSize: 12, marginTop: 5 }}>{this.state.deleteWarning}</p>
                        </div>

                        <div className="modal-footer">
                            <div id="addCategoryButtonContainer" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                {
                                    this.state.deletingAccess &&
                                    <Spinner />
                                }
                                <button className="btn btn-outline-primary waves-effect" onClick={() => this.state.deleteAccessText == 'DELETE PERMANENTLY' ? this.apiCallToDeleteHoliday() : this.setState({ deleteWarning: 'Please enter DELETE PERMANENTLY to delete access.' })} disabled={this.state.deletingAccess}>Yes</button>
                                <button className="btn btn-primary" onClick={() => this.closeDeleteAccess()}>No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CHECK ACCESS FOR DELETE OPERATION
    checkDeleteAccess = () => {
        const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'delete');

        if (deleteGrantAccess !== undefined) {
            this.setState({
                deleteAccess: true
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    //METHOD TO CHECK ACCESS FOR EDIT OPERATION
    checkEditAccess = (holiday) => {
        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'edit');

        if (editGrantAccess !== undefined) {
            let streamIds = holiday.sidArray;
            let sidWiseName = holiday.sidWiseName;
            let selectedDepartmentObject = [];
            Object.keys(sidWiseName).map((sid) => {
                let stream_name = sidWiseName[sid];
                let options = { "value": sid, "label": stream_name };
                selectedDepartmentObject.push(options);
            })

            let selectedDepartment = holiday.sidArray;

            this.setState({
                addHoliday: true,
                holidayEditMode: true,
                holidayCopyMode: false,
                title: holiday.Title,
                selectedIid: holiday.CollegeId,
                selectedAcademicYearObject: [holiday.AcayrID],
                validFromDate: holiday.Fromdate,
                validToDate: holiday.Todate,
                editAcaYear: holiday.AcayrID,
                selectedDepartment: selectedDepartment,
                uniqueIdEdit: holiday.Uniqueid,
                selectedDepartmentObject
            }, () => {
                this.GetInstituteStreamsObject();
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO CLOSE DELETE ACCESS
    closeDeleteAccess = () => {
        this.setState({
            deleteAccess: false,
            deletingAccess: false,
            deleteAccessText: '',
            deleteWarning: ''
        });
    }

    // METHOD TO GET EVENT BY NAME
    getHolidayByTitle = (e) => {
        if (e.charCode == 13) {
            this.setState({
                pageIndex: 1,
                offset: 0,
                filterApplied: true
            }, () => {
                // METHOD CALLED TO GET HOLIDAY DETAILS
                this.apiCallToGetHolidaysList();
            });
        }
    }

    render() {

        let filters = [];
        if (this.state.selectedDepartmentObject.length > 0) {
            const labelsArray = this.state.selectedDepartmentObject.map(item => item.label);
            filters.push(`Department : ${labelsArray.join(', ')}`);
        }

        if (this.state.selectedAcademicYearObject.length > 0) {
            const labelsArray = this.state.selectedAcademicYearObject.map(item => item.label);
            filters.push(`AcademicYear : ${labelsArray.join(', ')}`);
        }

        return (
            <>
                <div>
                    <div className="ruleLink">
                        <p className={this.state.activeTab == 'holidays' ? 'activeTabs settingTab' : 'settingTab'} onClick={() => this.selectEventType('holidays')}>Holidays</p>
                        <p className={this.state.activeTab == 'weekOff' ? 'activeTabs settingTab' : 'settingTab'} onClick={() => this.selectEventType('weekOff')}>Week Offs</p>
                    </div>
                    {
                        this.state.activeTab == 'holidays' ?
                            (
                                <div>
                                    <div className="pl-0 pt-3 col-md-12">
                                        <div className="row d-flex align-items-center justify-content-between">
                                            <span className="col-md-8 pl-0">
                                                <div className="row">
                                                    <div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '6px', paddingBottom: '6px' }}
                                                            placeholder="Search by Holiday Title"
                                                            value={this.state.filterTitle} // Use the value prop to control the input
                                                            onChange={(e) => this.setState({ filterTitle: e.target.value })}
                                                            onKeyPress={(e) => this.getHolidayByTitle(e)}

                                                        />
                                                        <p className="d-flex justify-content-end" style={{ color: '#7A7A7A', fontSize: '10px' }}>Press enter to search.</p>
                                                    </div> &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <div style={{ paddingTop: '10px', fontSize: "14px", textDecoration: 'underline', color: '#0080ff', cursor: 'pointer' }}
                                                        onClick={() => this.setState({ filterModal: true })}
                                                    >
                                                        + Advanced Filters <FontAwesomeIcon icon={["fa", "filter"]} />
                                                    </div>
                                                </div>
                                            </span>
                                            <div className='pt-0'>
                                                <button type="button" onClick={() => (this.checkAddHoliday(), this.AcademicYearList())} className="btn btn-primary">
                                                    <FontAwesomeIcon icon={["fa", "plus"]} /> &nbsp;
                                                    Add New Holiday
                                                </button>
                                            </div>
                                        </div>

                                        {
                                            this.state.filterApplied &&
                                            (
                                                <div className="row my-2">
                                                    <div className="col-md-12 pl-0 pr-0">
                                                        <div className="filter_containers appliedFilteredDivs" style={{ background: "#FFF", display: "flex", alignItems: "end" }}>
                                                            <div>
                                                                <div style={{ paddingLeft: '15px' }}>
                                                                    <label style={{ fontSize: 12, marginBottom: 0 }}>Applied Filters</label>
                                                                    <div style={{ display: "flex", gap: 10, overflowX: "auto" }}>

                                                                        {this.state.filterIid.length > 0 && <div class="appliedHolidayFilters"><span>Institute</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterIid: "", filterDepartment: "" }, () => this.apiCallToGetHolidaysList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                                        {this.state.filterAcaYr.length > 0 && <div class="appliedHolidayFilters"><span>Academic Year</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterAcaYr: "" }, () => this.apiCallToGetHolidaysList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                                        {this.state.filterDepartment.length > 0 && <div class="appliedHolidayFilters"><span>Department</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterDepartment: "" }, () => this.apiCallToGetHolidaysList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                                        {this.state.filterTitle.length > 0 && <div class="appliedHolidayFilters"><span> Title</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterTitle: "" }, () => this.apiCallToGetHolidaysList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                                        {this.state.filterFromDate.length > 0 && <div class="appliedHolidayFilters"><span>From Date</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterFromDate: "" }, () => this.apiCallToGetHolidaysList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                                        {this.state.filterToDate.length > 0 && <div class="appliedHolidayFilters"><span>To Date</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ filterToDate: "" }, () => this.apiCallToGetHolidaysList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div >
                                                                <span
                                                                    className="mt-3 clearContainer"
                                                                    title="Click to clear filters"
                                                                    style={{ fontSize: 13, color: '#007bff', cursor: 'pointer', fontWeight: 'bold' }}
                                                                    onClick={() => this.setState({ filterApplied: false, filterIid: "", filterAcaYr: "", filterDepartment: "", filterTitle: "", filterFromDate: "", filterToDate: "" }, () => this.apiCallToGetHolidaysList())}
                                                                >
                                                                    <span className='clearIcon'>
                                                                        <FontAwesomeIcon icon={['fas', 'brush']} style={{ transform: "rotate(180deg)" }} />
                                                                    </span> &nbsp;&nbsp;
                                                                    <span style={{ textDecoration: "underline" }}>
                                                                        Clear Filters
                                                                    </span>
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }


                                        <div className='noteRectangle'>
                                            <p style={{ color: '#FF0000', fontSize: '12px' }}>Note -</p>
                                            <p className='pl-3' style={{ color: '#000000', fontSize: '12px' }}><FontAwesomeIcon style={{ fontSize: "4px" }} icon={["fa", "circle"]} /> &nbsp; The Library fine will be automatically skipped for the added holidays for students.</p>
                                            <p className='pl-3' style={{ color: '#000000', fontSize: '12px' }}><FontAwesomeIcon style={{ fontSize: "4px" }} icon={["fa", "circle"]} /> &nbsp; Holidays added from here will be applicable to the students only and Faculty Holidays will be managed from the Leave Management System.</p>
                                        </div>
                                        <div className='pt-3 pb-2'>
                                            <div className='table-responsive' style={{ paddingLeft: '3%', paddingRight: '3%', maxHeight: '55vh', overflowY: 'scroll' }}>
                                                <table class="table table-hover table-borderless">
                                                    <thead style={{ backgroundColor: "#ffffff", position: 'sticky', top: '-1%' }}>
                                                        <tr>
                                                            <th scope="col">Sr. No.</th>
                                                            <th scope="col">Title</th>
                                                            <th scope="col">Institute</th>
                                                            <th scope="col">Academic Year</th>
                                                            <th scope="col">Department</th>
                                                            <th scope="col">From Date - To Date</th>
                                                            <th scope="col">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    {
                                                        this.state.Loadingholidays ?
                                                            <tr>
                                                                <Spinner />
                                                            </tr>
                                                            :
                                                            Object.keys(this.state.holidayList).length > 0 ?
                                                                Object.values(this.state.holidaySortedIdArray).map((holidays, index) => {
                                                                    const holiday = this.state.holidayList[holidays];
                                                                    const Fromdate = moment(holiday.Fromdate).format('Do MMM, YY');
                                                                    const Todate = moment(holiday.Todate).format('Do MMM, YY');
                                                                    return (
                                                                        <>
                                                                            <tbody>
                                                                                <tr class="shadow-row">
                                                                                    <th className='fs-12'>{this.state.offset + index + 1}</th>
                                                                                    <td className='fs-12' title={holiday.Title}>{holiday.Title.length > 25 ? holiday.Title.substring(0, 25) + '...' : holiday.Title}</td>
                                                                                    <td className='fs-12'>{holiday.instituteName}</td>
                                                                                    <td className='fs-12'>{holiday.AcademicYear}</td>
                                                                                    <td className='fs-12' title={holiday.streamNameArray.join(', ')}>
                                                                                        {holiday.streamNameArray.join(', ').length > 40 ? holiday.streamNameArray.join(', ').substring(0, 40) + '...' : holiday.streamNameArray.join(', ')}
                                                                                    </td>
                                                                                    <td className='fs-12'>{Fromdate + ' ' + '-' + ' ' + Todate}</td>
                                                                                    <td>
                                                                                        <FontAwesomeIcon style={{ fontSize: '14px', color: 'rgb(63, 59, 59)', cursor: 'pointer' }} onClick={() => { this.checkEditAccess(holiday) }} title='Click to edit' icon={["fa", "edit"]} />&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                        <FontAwesomeIcon style={{ fontSize: '14px', color: 'rgb(63, 59, 59)', cursor: 'pointer' }} onClick={() => { this.setState({ deletingId: holiday.Uniqueid, CollegeId: holiday.CollegeId }, () => this.checkDeleteAccess()) }} title='Click to delete' icon={["fa", "trash-alt"]} />&nbsp;&nbsp;&nbsp;&nbsp;
                                                                                        <FontAwesomeIcon style={{ fontSize: '14px', color: 'rgb(63, 59, 59)', cursor: 'pointer' }} onClick={() => { this.checkCopyAccess(holiday) }} title='Click to copy' icon={["fa", "copy"]} />
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </>
                                                                    )
                                                                })
                                                                :
                                                                <tr>
                                                                    <td style={{ padding: 5 }} colSpan={13}>No holiday is added yet. Please click on 'Add New Holiday' to add holiday.</td>
                                                                </tr>
                                                    }
                                                </table>
                                            </div>
                                        </div>
                                        {
                                            !this.state.Loadingholidays &&
                                            <div className="pl-3 pr-4">
                                                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                                                    <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                                        <span >Show</span>
                                                        <select
                                                            className="mx-2"
                                                            value={this.state.limit}
                                                            onChange={(e) => this.selectLimit(e)}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={40}>40</option>
                                                            <option value={100}>100</option>
                                                            <option value={250}>250</option>
                                                        </select>
                                                        <span>entries</span>
                                                    </div>
                                                    <div id="paginationContainer">
                                                        <Pagination
                                                            activePage={this.state.pageIndex}
                                                            itemsCountPerPage={this.state.limit}
                                                            totalItemsCount={this.state.totalHolidays}
                                                            pageRangeDisplayed={3}
                                                            onChange={(num) => this.updatePaginationCount(num)}
                                                        />
                                                    </div>
                                                    <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {this.state.totalHolidays} </p>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            )
                            :
                            (
                                <WeekOffs />
                            )
                    }
                </div>

                {
                    this.returnAddNewHoliday()
                }
                {
                    this.returnAdvancedFilterModal()
                }
                {
                    this.returnDeleteAccess()
                }
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
            </>
        )
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        assignedInstitute: { ...store.RouteMenuReducer.assignedInstitute },
        assignedIIDArray: { ...store.RouteMenuReducer.assignedIIDArray },
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
    };
};


export default connect(mapStateToProps)(Holidays);
